import { useEffect, useRef, useState } from 'react';

export function useAudio(url: string) {
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const play = async (
    options: {
      duration?: number;
      onEnd?: () => void;
    } = {}
  ) => {
    const { duration, onEnd } = options;

    if (!audioRef.current) return;
    try {
      await audioRef.current.play();
      if (duration) {
        setTimeout(() => {
          onEnd?.();
        }, duration);
      }
      setIsPlaying(true);
    } catch (error) {
      console.error('Failed to play audio:', error);
    }
  };

  const pause = () => {
    if (!audioRef.current) return;
    audioRef.current.pause();
    setIsPlaying(false);
  };

  const reset = () => {
    if (!audioRef.current) return;
    audioRef.current.currentTime = 0;
    audioRef.current.load();
    setIsPlaying(false);
  };

  useEffect(() => {
    if (!audioRef.current) {
      const audio = new Audio(url);
      audioRef.current = audio;
    }

    return () => {
      reset();
    };
  }, [url]);

  return { play, pause, reset, isPlaying };
}
